import { Component, OnInit } from '@angular/core';
import {
  TextTemplate
} from "../../common/models/flow.dto";

import {TextTemplatesService} from "../text-templates.service";
import { Observable } from 'rxjs';
import { Router } from '@angular/router';
import { SubHeaderService } from '../../core/services/sub-header.service';
import { SubHeader } from '../../core/models/sub-header.model';
@Component({
    selector: 'app-text-templates-list',
    templateUrl: './text-templates-list.component.html',
    styleUrls: ['./text-templates-list.component.scss'],
    standalone: false
})
export class TextTemplatesListComponent implements OnInit {

    templates: Observable<TextTemplate[]>;
    subHeader: SubHeader = new SubHeader({ title: "Manage Text Templates" });
    constructor(public readonly _svc: TextTemplatesService, private subHeaderService: SubHeaderService, public readonly _router:Router) {

    }


  ngOnInit() {
    this.subHeaderService.updateSubHeader(this.subHeader);
    this.templates = this._svc.list();
  }

  delete(id:string){
    this._svc.delete(id);
  }
  edit(id:string){
    this._router.navigate(["text-templates",id]);
  }
  create(){
    this._router.navigate(["text-templates",'new']);
  }
}
